import axios from "axios";
import qs from "qs";
const client = axios.create({
  baseURL:
    process.env.NODE_ENV === "development" ? "http://localhost:62290/" : "/",
  timeout: 30000,
});

const defaultParamSerializer = (params) =>
  qs.stringify(params, { arrayFormat: "repeat" });

export default {
  getServices(providerId, addServiceKeys) {
    return client
      .get(
        "api/services",

        {
          params: {
            providerId: providerId,
            addServiceKeys: addServiceKeys,
          },
          paramsSerializer: defaultParamSerializer,
        }
      )
      .then((response) => response.data);
  },
  getTranslations() {
    return client.get("api/translations").then((response) => response.data);
  },
  getProviders(serviceIds) {
    return client
      .get("api/providers", {
        params: {
          serviceIds: serviceIds,
        },
        paramsSerializer: defaultParamSerializer,
      })
      .then((response) => response.data);
  },
  getAvailability(serviceIds, providerId, startDate) {
    return client
      .get("api/availability", {
        params: {
          serviceIds: serviceIds,
          providerId: providerId,
          startDate: startDate,
        },
        paramsSerializer: defaultParamSerializer,
      })
      .then((response) => response.data);
  },
  getSlots(serviceIds, providerId, date) {
    return client
      .get("api/slots", {
        params: {
          serviceIds: serviceIds,
          providerId: providerId,
          date: date,
        },
        paramsSerializer: defaultParamSerializer,
      })
      .then((response) => response.data);
  },
  reserverSlot(slotData, reservationId) {
    return client.post("api/reserveslot", {
      slotData: slotData,
      reservationId: reservationId,
    });
  },
  confirm(order) {
    return client.post("api/confirmreservation", order);
  },
  uploadFiles(formData) {
    return client.post("api/upload", formData);
  },
  getReservation(reservationKey) {
    return client
      .get("api/reservation/" + reservationKey)
      .then((response) => response.data);
  },
  cancelReservation(reservationId) {
    return client.post("/api/reservation/" + reservationId + "/cancel");
  },
};
